<template></template>
<script>
export default {
  data() {
    return {
      scrollElementList: []
    };
  },
  activated: function() {
    this.scrollElementList.forEach(item => {
      item.element.scrollTop = item.top;
    });
  },
  beforeRouteLeave: function(to, from, next) {
    if (this.scrollElementList.length < 1) {
      this.addScrollElement(this.$refs.scrollElement);
    }

    this.scrollElementList.forEach(item => {
      item.top = item.element.scrollTop;
    });
    next();
  },
  methods: {
    addScrollElement(elem) {
      if (!elem) {
        return;
      }
      this.scrollElementList.push({
        element: elem,
        top: 0
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// KeepScroll.vue?287e1df5